import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { extractApiErrorMessage } from '../utils/api-error';

/**
 * Normaliza los errores HTTP para que el mensaje real del backend
 * sea accesible desde cualquier lugar que lea `err.error.message`,
 * `err.error.detail`, `err.friendlyMessage` o `err.message`.
 *
 * El backend PidePaYa devuelve errores con forma:
 *   { succeeded: false, errors: string[], statusCode: number }
 *
 * Sin este interceptor, el call site tenía que leer manualmente
 * `err.error.errors[0]`. Con él, cualquier acceso común funciona.
 *
 * El interceptor NO muestra toasts por sí solo — eso sigue siendo
 * responsabilidad del componente (para que decida si mostrarlo o no).
 */
export const errorNormalizerInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        const message = extractApiErrorMessage(err, '');
        if (message) {
          const body = err.error;
          if (body && typeof body === 'object') {
            try {
              (body as Record<string, unknown>)['message'] ??= message;
              (body as Record<string, unknown>)['detail'] ??= message;
            } catch {
              // cuerpo congelado — ignorar
            }
          }
          (err as unknown as Record<string, unknown>)['friendlyMessage'] = message;
        }
      }
      return throwError(() => err);
    })
  );
};
